<script setup>
import Vue3Html2pdf from 'vue3-html2pdf';
import { ref, defineExpose, onMounted } from 'vue';

const html2Pdf = ref();
const isMobile = ref(false);

const props = defineProps({
  widthContent: {
    type: String,
    default: '800',
  },
  pdfFormatContent: {
    type: String,
    default: 'a4',
  },
  pdfOrientation: {
    type: String,
    default: 'portrait',
  },
  manualPagination: {
    type: Boolean,
    default: false,
  },
});

function generateReport() {
  html2Pdf.value.generatePdf();
}

function checkScreen() {
  isMobile.value = window.matchMedia('(max-width: 768px)').matches;
}

onMounted(() => {
  checkScreen();
});

defineExpose({ html2Pdf, generateReport, props });
</script>

<template>
  <vue3-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="!isMobile" :paginate-elements-by-height="1100" filename="Ticket" :pdf-quality="2" :manual-pagination="props.manualPagination" :pdf-format="props.pdfFormatContent" :pdf-orientation="props.pdfOrientation" :pdf-content-width="`${props.widthContent}px`" @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)" ref="html2Pdf">
    <template #pdf-content>
      <slot></slot>
    </template>
  </vue3-html2pdf>
</template>
